import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Portal() {
  return (
    <main>
      <Header />
      <section className="section portal-section">
        <form
          className="login-card"
          onSubmit={(event) => event.preventDefault()}
        >
          <span className="eyebrow">Área reservada</span>
          <h1>Portal do Cliente</h1>
          <p>Acompanhe inscrições, pagamentos e documentos num único lugar.</p>
          <label>
            Email
            <input type="email" placeholder="nome@email.com" />
          </label>
          <label>
            Palavra-passe
            <input type="password" placeholder="••••••••" />
          </label>
          <button className="button button-gold" type="submit">
            Entrar
          </button>
          <Link to="/contato">Não consegue entrar? Fale connosco.</Link>
        </form>
      </section>
      <Footer />
    </main>
  );
}
